<template>
  <div class="main">
    <el-dialog
      :title="openData.title"
      :visible.sync="openData.state"
      :close-on-click-modal="false"
      width="70%"
      class="dialog_container"
      @close="dialogVisibleClone"
    >
      <div class="btnGroup">
        <el-button :type="step == 0 ? 'primary' : 'info'" @click="stepTap(0)"
          >机构基本信息</el-button
        >
        <el-button :type="step == 1 ? 'primary' : 'info'" @click="stepTap(1)"
          >机构房屋场地信息</el-button
        >
        <el-button :type="step == 2 ? 'primary' : 'info'" @click="stepTap(2)"
          >机构设施设备信息</el-button
        >
      </div>
      <div class="dialog_content">
        <el-form
          label-position="left"
          label-width="160px"
          ref="formData"
          :model="formData"
          :rules="formDataRules"
        >
          <div v-show="step == 0">
            <el-row>
              <el-col :span="11">
                <el-form-item label="机构名称：" prop="organizationName">
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.trim="formData.organizationName"
                    placeholder="请输入机构名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="机构负责人：" prop="principal">
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.trim="formData.principal"
                    placeholder="请输入机构负责人"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系电话：" prop="telphone">
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.number="formData.telphone"
                    placeholder="请输入联系电话"
                  ></el-input>
                </el-form-item>
                <el-form-item label="统一社会信用代码：" prop="code">
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.number="formData.code"
                    placeholder="请输入统一社会信用代码"
                  ></el-input>
                </el-form-item>
                <el-form-item label="机构等级：" prop="organizationLeval">
                  <el-radio-group
                    :disabled="openData.title == '详情'"
                    v-model="formData.organizationLeval"
                  >
                    <el-radio :label="1">A</el-radio>
                    <el-radio :label="2">AA</el-radio>
                    <el-radio :label="3">AAA</el-radio>
                    <el-radio :label="4">AAAA</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="是否设医疗机构：" prop="medicalCareFlag">
                  <el-radio-group
                    :disabled="openData.title == '详情'"
                    v-model="formData.medicalCareFlag"
                  >
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="11" :offset="1">
                <el-form-item label="站点类型：" prop="mechanismNature">
                  <el-radio-group
                    :disabled="openData.title == '详情'"
                    v-model="formData.mechanismNature"
                  >
                    <el-radio :label="1">助养型</el-radio>
                    <el-radio :label="2">护理型</el-radio>
                    <el-radio :label="3">居养型</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="法人代表：" prop="legalRepresentative">
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.trim="formData.legalRepresentative"
                    placeholder="请输入法人代表"
                  ></el-input>
                </el-form-item>

                <el-form-item label="联系电话：" prop="phone">
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.number="formData.phone"
                    placeholder="请输入联系电话"
                  ></el-input>
                </el-form-item>
                <el-form-item label="养老机构许可证：" prop="licence">
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.number="formData.licence"
                    placeholder="请输入养老机构许可证"
                  ></el-input>
                </el-form-item>
                <el-form-item label="卫生许可证：" prop="licenceFlag">
                  <el-radio-group
                    :disabled="openData.title == '详情'"
                    v-model="formData.licenceFlag"
                  >
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">无</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="对外服务电话：" prop="servicePhone">
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.trim="formData.servicePhone"
                    placeholder="请输入对外服务电话"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="医疗服务方式：" prop="medicalCareWay">
              <el-radio-group
                v-model="formData.medicalCareWay"
                :disabled="openData.title == '详情'"
              >
                <el-radio label="1">自办医院</el-radio>
                <el-radio label="2">护理站</el-radio>
                <el-radio label="3">医务室</el-radio>
                <el-radio label="4">医院</el-radio>
                <el-radio label="5">乡镇卫生院</el-radio>
                <el-radio label="6">村（社区）卫生机构（中心）</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-row>
              <el-col :span="11">
                <el-form-item
                  label="是否具备医保定点资格："
                  prop="medicalPointFlag"
                >
                  <el-radio-group
                    :disabled="openData.title == '详情'"
                    v-model="formData.medicalPointFlag"
                  >
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">无</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="机构类型大类：" prop="mechanismBigType">
                  <el-radio-group
                    :disabled="openData.title == '详情'"
                    v-model="formData.mechanismBigType"
                  >
                    <el-radio :label="1">国办</el-radio>
                    <el-radio :label="2">民办</el-radio>
                    <el-radio :label="3">乡镇（街道）敬老院</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="营业执照：" prop="businessLicense">
                  <el-upload
                    :disabled="openData.title == '详情'"
                    class="upload-demo"
                    :action="baseUrl"
                    :on-success="licenseSuccess"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :show-file-list="false"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed"
                  >
                    <div v-if="openData.title != '详情'">
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                    </div>
                    <div v-if="formData.businessLicense.length">
                      <div>
                        <p
                          v-for="(item, index) in formData.businessLicense"
                          :key="index"
                        >
                          <img :src="item" class="uplogImg" alt="" srcset="" />
                        </p>
                      </div>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="11" :offset="1">
                <el-form-item label="机构用房来源" prop="housResource">
                  <el-radio-group
                    :disabled="openData.title == '详情'"
                    v-model="formData.housResource"
                  >
                    <el-radio label="1">自有产权</el-radio>
                    <el-radio label="2">租赁</el-radio>
                    <el-radio label="3">合作使用</el-radio>
                    <el-radio label="4">其他</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="机构类型小类：" prop="mechanismSmallType">
                  <el-radio-group
                    v-model="formData.mechanismSmallType"
                    :disabled="openData.title == '详情'"
                  >
                    <el-radio :label="1">事业登记</el-radio>
                    <el-radio :label="2">民非登记</el-radio>
                    <el-radio :label="3">未登记</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="机构图片：" prop="photo">
                  <el-upload
                    :disabled="openData.title == '详情'"
                    class="upload-demo"
                    :action="baseUrl"
                    :on-success="photoSuccess"
                    :show-file-list="false"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed"
                  >
                    <div v-if="openData.title != '详情'">
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                    </div>
                    <div v-if="formData.photo.length">
                      <div>
                        <p v-for="(item, index) in formData.photo" :key="index">
                          <img :src="item" class="uplogImg" alt="" srcset="" />
                        </p>
                      </div>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="简介：" prop="introduction">
              <quillEditor
                style="width: 100%"
                :disabled="openData.title == '详情'"
                v-model="formData.introduction"
              >
              </quillEditor>
            </el-form-item>
            <el-form-item label="机构地点：">
              <el-button
                type="success"
                class="button"
                size="mmedium"
                style="margin-bottom: 25px"
                @click="mapTap"
                >显示位置</el-button
              >
              <div v-show="showMap">
                <el-row>
                  <el-col :span="4">
                    <el-form-item>
                      <el-select
                        v-model="formData.provinceId"
                        placeholder="请选择省"
                        @change="handleProvince"
                        :disabled="
                          normalInfo.orgLevel == 1 ||
                          normalInfo.orgLevel == 2 ||
                          normalInfo.orgLevel == 3 ||
                          normalInfo.orgLevel == 4 ||
                          normalInfo.orgLevel == 5 ||
                          openData.title == '详情'
                        "
                        style="width: 100%"
                        ref="selectShengChange"
                      >
                        <el-option
                          v-for="(item, index) in provinceList"
                          :key="index"
                          :label="item.name"
                          :value="item.adcode"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" :offset="1">
                    <el-select
                      v-model="formData.cityId"
                      placeholder="请选择市"
                      :disabled="
                        normalInfo.orgLevel == 2 ||
                        normalInfo.orgLevel == 3 ||
                        normalInfo.orgLevel == 4 ||
                        normalInfo.orgLevel == 5 ||
                        openData.title == '详情'
                      "
                      @change="handleCity"
                      ref="selectShiChange"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item, index) in cityList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1">
                    <el-select
                      v-model="formData.zoneId"
                      placeholder="请选择区"
                      @change="handleArea"
                      :disabled="
                        normalInfo.orgLevel == 3 ||
                        normalInfo.orgLevel == 4 ||
                        normalInfo.orgLevel == 5 ||
                        openData.title == '详情'
                      "
                      ref="selectQuChange"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item, index) in areaList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1">
                    <el-select
                      v-model="formData.streetId"
                      placeholder="请选择街道"
                      :disabled="
                        normalInfo.orgLevel == 4 ||
                        normalInfo.orgLevel == 5 ||
                        openData.title == '详情'
                      "
                      @change="streetChange"
                      ref="selectJiedaoChange"
                    >
                      <el-option
                        v-for="(item, index) in streetList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode + index"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1">
                    <el-select
                      v-model="formData.shequId"
                      placeholder="请选择社区"
                      :disabled="
                        normalInfo.orgLevel == 5 || openData.title == '详情'
                      "
                      ref="selectShequChange"
                      @change="handleCommunityChange"
                    >
                      <el-option
                        v-for="item in communityList"
                        :key="item.id"
                        :label="item.address"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <input
                  v-model.trim="formData.address"
                  :disabled="openData.title == '详情'"
                  id="tipinput"
                  class="el-input__inner"
                  :class="openData.title == '详情' ? 'innerCur' : ''"
                  @focus="getMap('tipinput')"
                  placeholder="请输入关键字"
                  autocomplete="off"
                />
                <div class="map_container">
                  <div
                    class="map_right"
                    id="container"
                    style="width: 100%; height: 300px"
                  ></div>
                </div>
              </div>
            </el-form-item>
          </div>
          <div v-show="step == 1">
            <el-row>
              <el-col :span="11">
                <el-form-item
                  label="实际投入资金："
                  prop="actualInvestmentMoney"
                >
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.number="formData.actualInvestmentMoney"
                    placeholder="请输入实际投入资金"
                  ></el-input>
                </el-form-item>
                <el-form-item label="员工人数：" prop="staffNumber">
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.number="formData.staffNumber"
                    placeholder="请输入员工人数"
                  ></el-input>
                </el-form-item>
                <el-form-item label="房屋类型：" prop="houseType">
                  <el-radio-group
                    :disabled="openData.title == '详情'"
                    v-model="formData.houseType"
                  >
                    <el-radio :label="1">楼房</el-radio>
                    <el-radio :label="2">平房</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="占地面积：" prop="areaCovered">
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.number="formData.areaCovered"
                    placeholder="请输入占地面积"
                  ></el-input>
                  <span>单位：平方米</span>
                </el-form-item>
                <el-form-item
                  label="内配有卫生间的房间总数："
                  prop="yesToiletNumber"
                >
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.number="formData.yesToiletNumber"
                    placeholder="请输入房间总数"
                  ></el-input>
                  <span>单位：间</span>
                </el-form-item>
                <el-form-item
                  label="服务对象居住房间总数："
                  prop="serviceHouseNumber"
                >
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.number="formData.serviceHouseNumber"
                    placeholder="请输入房间总数"
                  ></el-input>
                  <span>单位：间</span>
                </el-form-item>
                <el-form-item label="户外活动产地：" prop="activityVenues">
                  <el-radio-group
                    :disabled="openData.title == '详情'"
                    v-model="formData.activityVenues"
                  >
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">没有</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="养殖产地：" prop="plantingArea">
                  <el-radio-group
                    v-model="formData.plantingArea"
                    :disabled="openData.title == '详情'"
                  >
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">没有</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="停车场：" prop="parkingLotFlag">
                  <el-radio-group
                    v-model="formData.parkingLotFlag"
                    :disabled="openData.title == '详情'"
                  >
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">没有</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="11" :offset="1">
                <el-form-item label="建设补助资金：" prop="buildSubsidyMoney">
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.number="formData.buildSubsidyMoney"
                    placeholder="请输入资金"
                  ></el-input>
                </el-form-item>
                <el-form-item label="房屋性质：" prop="houseNature">
                  <el-radio-group
                    :disabled="openData.title == '详情'"
                    v-model="formData.houseNature"
                  >
                    <el-radio :label="1">新建</el-radio>
                    <el-radio :label="2">租房</el-radio>
                    <el-radio :label="3">改造</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="房屋建设时间：" prop="houseBuildTime">
                  <el-date-picker
                    :disabled="openData.title == '详情'"
                    v-model="formData.houseBuildTime"
                    type="year"
                    placeholder="选择年"
                  >
                  </el-date-picker>
                  <span>年</span>
                </el-form-item>
                <el-form-item label="建筑面积：" prop="areaBuilding">
                  <el-input
                    :disabled="openData.title == '详情'"
                    v-model.number="formData.areaBuilding"
                    placeholder="请输入建筑面积"
                  ></el-input>
                  <span>单位：平方米</span>
                </el-form-item>
                <el-form-item
                  label="卫生间内有无紧急呼吸设备："
                  prop="panicButtonFlag"
                >
                  <el-radio-group
                    :disabled="openData.title == '详情'"
                    v-model="formData.panicButtonFlag"
                  >
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">没有</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="服务床位总数：" prop="serviceBedNumber">
                  <el-input
                    v-model.number="formData.serviceBedNumber"
                    :disabled="openData.title == '详情'"
                    placeholder="请输入床位数量"
                  ></el-input>
                  <span>单位：张</span>
                </el-form-item>
                <el-form-item label="种植场地：" prop="plantingArea">
                  <el-radio-group
                    v-model="formData.plantingArea"
                    :disabled="openData.title == '详情'"
                  >
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">没有</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="设有消防控制室：" prop="fireControlFlag">
                  <el-radio-group
                    :disabled="openData.title == '详情'"
                    v-model="formData.fireControlFlag"
                  >
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">没有</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="是否开展居家和社区养老服务："
                  prop="carryOutServicesFlag"
                >
                  <el-radio-group v-model="formData.carryOutServicesFlag">
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">没有</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="楼层平面图：" prop="floorPlan">
              <el-upload
                :disabled="openData.title == '详情'"
                class="upload-demo"
                :action="baseUrl"
                :on-success="houseSuccess"
                :show-file-list="false"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="3"
                :on-exceed="handleExceed"
              >
                <div v-if="openData.title != '详情'">
                  <el-button size="small" type="primary">点击上传</el-button>
                </div>
                <div v-if="formData.floorPlan.length">
                  <div>
                    <p v-for="(item, index) in formData.floorPlan" :key="index">
                      <img :src="item" class="uplogImg" alt="" srcset="" />
                    </p>
                  </div>
                </div>
              </el-upload>
            </el-form-item>
          </div>
          <div v-show="step == 2">
            <el-form-item label="公共服务用房：" prop="publicServiceHousing">
              <el-checkbox-group
                v-model="formData.publicServiceHousing"
                :disabled="openData.title == '详情'"
              >
                <el-checkbox
                  v-for="(item, index) in publicHouse"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="医疗康复用房："
              prop="medicalRehabilitationHousing"
            >
              <el-checkbox-group
                v-model="formData.medicalRehabilitationHousing"
                :disabled="openData.title == '详情'"
              >
                <el-checkbox
                  v-for="(item, index) in medicalRehabilitation"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="文化娱乐用房："
              prop="culturalEntertainmentHousing"
            >
              <el-checkbox-group
                v-model="formData.culturalEntertainmentHousing"
                :disabled="openData.title == '详情'"
              >
                <el-checkbox
                  v-for="(item, index) in culturalEntertainment"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="行政辅助用房："
              prop="administrativeAuxiliaryHousing"
            >
              <el-checkbox-group
                v-model="formData.administrativeAuxiliaryHousing"
                :disabled="openData.title == '详情'"
              >
                <el-checkbox
                  v-for="(item, index) in administrativeAssistance"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="房间设备：" prop="roomEquipment">
              <el-checkbox-group
                v-model="formData.roomEquipment"
                :disabled="openData.title == '详情'"
              >
                <el-checkbox
                  v-for="(item, index) in roomEquipment"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="健康一体机：">
              <el-select
                v-model="formData.deviceId"
                placeholder="请选择"
                style="width: 37%"
                :disabled="openData.title == '详情'"
              >
                <el-option
                  :label="item.venConding"
                  :value="item.venConding"
                  v-for="(item, index) in equipList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公共服务设备：" prop="publicServiceEquipment">
              <el-checkbox-group
                v-model="formData.publicServiceEquipment"
                :disabled="openData.title == '详情'"
              >
                <el-checkbox
                  v-for="(item, index) in publicService"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="医疗康复设备："
              prop="medicalRehabilitationEquipment"
            >
              <el-checkbox-group
                v-model="formData.medicalRehabilitationEquipment"
                :disabled="openData.title == '详情'"
              >
                <el-checkbox
                  v-for="(item, index) in medicalEquipment"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="安全保障设备：" prop="securityEquipment">
              <el-checkbox-group
                v-model="formData.securityEquipment"
                :disabled="openData.title == '详情'"
              >
                <el-checkbox
                  v-for="(item, index) in security"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="消防安全设备：" prop="fireSafetyEquipment">
              <el-checkbox-group
                v-model="formData.fireSafetyEquipment"
                :disabled="openData.title == '详情'"
              >
                <el-checkbox
                  v-for="(item, index) in fireSafety"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="行政办公设备：" prop="administrativeOffice">
              <el-checkbox-group
                v-model="formData.administrativeOffice"
                :disabled="openData.title == '详情'"
              >
                <el-checkbox
                  v-for="(item, index) in administrativeOffice"
                  :label="item.value"
                  :key="index"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer dialog-footer-btn"
        v-if="openData.title != '详情'"
      >
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialogVisibleClone">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseURL from "@/api/baseURL"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import { quillEditor } from "vue-quill-editor"
export default {
  props: ["openData"],
  components: {
    quillEditor,
  },
  data() {
    var chekPhone = (rule, value, callback) => {
      let validatePhone = /^1[3|4|5|6|7|8|9]\d{9}$/
      if (!validatePhone.test(value)) {
        return callback(new Error("手机号格式错误"))
      }
      callback()
    }
    return {
      normalInfo: {},
      showMap: false,
      fileList: [],
      checkList1: [],
      equipList: [],
      administrativeOffice: [
        { value: "0", label: "电脑" },
        { value: "1", label: "传真机" },
        { value: "2", label: "养老服务管理软件" },
        { value: "3", label: "电话" },
        { value: "4", label: "网络" },
        { value: "5", label: "办公用车" },
        { value: "6", label: "全无" },
      ],
      fireSafety: [
        { value: "0", label: "火灾自动报警系统" },
        { value: "1", label: "简易喷淋装置" },
        { value: "2", label: "应急照明" },
        { value: "3", label: "灭火器" },
        { value: "4", label: "消防水栓" },
        { value: "5", label: "防排烟风机" },
        { value: "6", label: "防火卷帘" },
        { value: "7", label: "其他" },
      ],
      publicHouse: [
        { value: "0", label: "厨房" },
        { value: "1", label: "餐厅" },
        { value: "2", label: "公共浴室" },
        { value: "3", label: "洗衣服" },
        { value: "4", label: "其他" },
      ],
      medicalRehabilitation: [
        { value: "0", label: "医务室" },
        { value: "1", label: "观察室" },
        { value: "2", label: "康复室" },
        { value: "3", label: "治疗室" },
        { value: "4", label: "灭菌室" },
        { value: "5", label: "隔离室" },
        { value: "6", label: "其他" },
      ],
      culturalEntertainment: [
        { value: "0", label: "活动室" },
        { value: "1", label: "健身房" },
        { value: "2", label: "书画室" },
        { value: "3", label: "图书室" },
        { value: "4", label: "手工制作表" },
        { value: "5", label: "多功能厅" },
        { value: "6", label: "音乐舞蹈室" },
        { value: "7", label: "心理辅导室" },
        { value: "8", label: "其他" },
      ],
      administrativeAssistance: [
        { value: "0", label: "办公室" },
        { value: "1", label: "门卫室" },
        { value: "2", label: "接待室" },
        { value: "3", label: "会议室" },
        { value: "4", label: "库房" },
        { value: "5", label: "培训室" },
        { value: "6", label: "其他" },
      ],
      roomEquipment: [
        { value: "0", label: "床头灯" },
        { value: "1", label: "电视机" },
        { value: "2", label: "电风扇" },
        { value: "3", label: "暖气" },
        { value: "4", label: "衣柜" },
        { value: "5", label: "空调" },
        { value: "6", label: "电冰箱" },
        { value: "7", label: "电话" },
        { value: "8", label: "洗衣机" },
        { value: "9", label: "电脑" },
        { value: "10", label: "网络" },
        { value: "11", label: "紧急呼叫设备" },
        { value: "12", label: "其他" },
      ],
      publicService: [
        { value: "0", label: "公用电话" },
        { value: "1", label: "普通电话" },
        { value: "2", label: "医用电梯" },
        { value: "3", label: "生活用车" },
        { value: "4", label: "公共上网区域" },
        { value: "5", label: "救护车" },
        { value: "6", label: "其他" },
        { value: "7", label: "全无" },
      ],
      medicalEquipment: [
        { value: "0", label: "制氧机" },
        { value: "1", label: "呼吸机" },
        { value: "2", label: "血压计" },
        { value: "3", label: "血糖仪" },
        { value: "4", label: "代步车" },
        { value: "5", label: "心电图" },
        { value: "6", label: "吸痰器" },
        { value: "7", label: "中医理疗康复" },
        { value: "8", label: "轮椅" },
        { value: "9", label: "其他" },
      ],
      security: [
        { value: "0", label: "轮椅坡道" },
        { value: "1", label: "安全扶手" },
        { value: "2", label: "防滑地板" },
        { value: "3", label: "监控设备" },
        { value: "4", label: "消防设备" },
        { value: "5", label: "无障碍卫生间" },
        { value: "6", label: "其他" },
      ],
      step: 0,
      baseURL: "",
      imageUrl: "",
      formData: {
        organizationName: "",
        mechanismNature: 1,
        principal: "",
        telphone: "",
        legalRepresentative: "",
        phone: "",
        code: "",
        licenceFlag: 1,
        organizationLeval: 1,
        licence: "",
        medicalCareFlag: 1,
        servicePhone: "",
        medicalCareWay: 1,
        medicalPointFlag: 1,
        housResource: 1,
        mechanismBigType: 1,
        mechanismSmallType: 1,
        businessLicense: [],
        photo: [],
        introduction: "",
        actualInvestmentMoney: "",
        buildSubsidyMoney: "",
        staffNumber: "",
        houseNature: 1,
        houseType: 1,
        houseBuildTime: "",
        areaCovered: "",
        areaBuilding: "",
        yesToiletNumber: "",
        panicButtonFlag: 1,
        serviceHouseNumber: "",
        serviceBedNumber: "",
        activityVenues: 1,
        plantingArea: 1,
        breedingArea: 1,
        fireControlFlag: 1,
        parkingLotFlag: 1,
        carryOutServicesFlag: 1,
        floorPlan: [],
        roomEquipment: [],
        publicServiceHousing: [],
        medicalRehabilitationHousing: [],
        culturalEntertainmentHousing: [],
        administrativeAuxiliaryHousing: [],
        publicServiceEquipment: [],
        medicalRehabilitationEquipment: [],
        securityEquipment: [],
        fireSafetyEquipment: [],
        administrativeOffice: [],
        provinceId: "", //省
        cityId: "", //市
        zoneId: "", //区
        streetId: "", //街道
        shequId: "", //社区
        address: "",
        longitude: "",
        latitude: "",
      },
      orgList: [],
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      myMap: null,
      isMap: true,
      polygons: [],
      polygon: [],
      marker: null, //地图标记点
      recMap: null,
      recIsMap: true,
      recPolygons: [],
      recPolygon: [],
      recMarker: null, //地图标记点
      formDataRules: {
        //表格表单验证
        organizationName: [
          {
            required: true,
            message: "机构名称不能为空",
            trigger: "blur",
          },
        ],
        mechanismNature: [
          {
            required: true,
            message: "机构性质不能为空",
            trigger: "blur",
          },
        ],
        principal: [
          {
            required: true,
            message: "负责人不能为空",
            trigger: "blur",
          },
        ],
        telphone: [
          {
            required: true,
            message: "负责人电话不能为空",
            trigger: "blur",
          },
          { validator: chekPhone, trigger: "blur" },
        ],
        legalRepresentative: [
          {
            required: true,
            message: "法人代表不能为空",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "blur",
          },
        ],
        licence: [
          {
            required: true,
            message: "养老机构许可证不能为空",
            trigger: "blur",
          },
        ],

        licenceFlag: [
          {
            required: true,
            message: "卫生许可证不能为空",
            trigger: "blur",
          },
        ],
        organizationLeval: [
          {
            required: true,
            message: "等级不能为空",
            trigger: "blur",
          },
        ],
        organizationLeval: [
          {
            required: true,
            message: "等级不能为空",
            trigger: "blur",
          },
        ],
        medicalCareFlag: [
          {
            required: true,
            message: "是否设医疗机构不能为空",
            trigger: "blur",
          },
        ],
        servicePhone: [
          {
            required: true,
            message: "对外服务电话不能为空",
            trigger: "blur",
          },
          { validator: chekPhone, trigger: "blur" },
        ],
        phone: [
          {
            required: true,
            message: "法人电话不能为空",
            trigger: "blur",
          },
          { validator: chekPhone, trigger: "blur" },
        ],

        medicalCareWay: [
          {
            required: true,
            message: "医疗服务方式不能为空",
            trigger: "blur",
          },
        ],
        medicalPointFlag: [
          {
            required: true,
            message: "是否具备医保定点资格不能为空",
            trigger: "blur",
          },
        ],
        housResource: [
          {
            required: true,
            message: "机构用房来源不能为空",
            trigger: "blur",
          },
        ],
        mechanismBigType: [
          {
            required: true,
            message: "机构类型大类不能为空",
            trigger: "blur",
          },
        ],
        mechanismSmallType: [
          {
            required: true,
            message: "机构类型小类不能为空",
            trigger: "blur",
          },
        ],
        // businessLicense: [
        //     {
        //         required: true,
        //         message: "营业执照不能为空",
        //         trigger: "blur",
        //         type: "array",
        //     },
        // ],
        // photo: [
        //     {
        //         required: true,
        //         message: "机构图片不能为空",
        //         trigger: "blur",
        //         type: "array",
        //     },
        // ],

        introduction: [
          {
            required: true,
            message: "简介不能为空",
            trigger: "blur",
          },
        ],
        actualInvestmentMoney: [
          {
            required: true,
            message: "实际投入建设资金不能为空",
            trigger: "blur",
          },
        ],
        buildSubsidyMoney: [
          {
            required: true,
            message: "建设补助资金不能为空",
            trigger: "blur",
          },
        ],
        staffNumber: [
          {
            required: true,
            message: "员工人数不能为空",
            trigger: "blur",
          },
        ],
        houseNature: [
          {
            required: true,
            message: "用房性质不能为空",
            trigger: "blur",
          },
        ],
        houseType: [
          {
            required: true,
            message: "房屋类型不能为空",
            trigger: "blur",
          },
        ],
        houseBuildTime: [
          {
            required: true,
            message: "房屋建设时间不能为空",
            trigger: "blur",
          },
        ],
        areaCovered: [
          {
            required: true,
            message: "占地面积能为空",
            trigger: "blur",
          },
        ],
        areaBuilding: [
          {
            required: true,
            message: "建筑面积不能为空",
            trigger: "blur",
          },
        ],
        yesToiletNumber: [
          {
            required: true,
            message: "内配有卫生间的房间总数不能为空",
            trigger: "blur",
          },
        ],
        panicButtonFlag: [
          {
            required: true,
            message: "卫生间是否有紧急呼叫设备不能为空",
            trigger: "blur",
          },
        ],
        serviceHouseNumber: [
          {
            required: true,
            message: "服务对象房间总数不能为空",
            trigger: "blur",
          },
        ],
        serviceBedNumber: [
          {
            required: true,
            message: "服务床位总数不能为空",
            trigger: "blur",
          },
        ],
        plantingArea: [
          {
            required: true,
            message: "种植场地不能为空",
            trigger: "blur",
          },
        ],
        breedingArea: [
          {
            required: true,
            message: "养殖场地不能为空",
            trigger: "blur",
          },
        ],
        fireControlFlag: [
          {
            required: true,
            message: "是否设有消防控制不能为空",
            trigger: "blur",
          },
        ],
        parkingLotFlag: [
          {
            required: true,
            message: "停车场不能为空",
            trigger: "blur",
          },
        ],
        carryOutServicesFlag: [
          {
            required: true,
            message: "是否开展居家和社区养老服务不能为空",
            trigger: "blur",
          },
        ],
        // floorPlan: [
        //     {
        //         required: true,
        //         message: "楼层平面图不能为空",
        //         trigger: "blur",
        //         type: "array",
        //     },
        // ],
        publicServiceHousing: [
          {
            required: true,
            message: "公共服务用房不能为空",
            trigger: "blur",
            type: "array",
          },
        ],
        medicalRehabilitationHousing: [
          {
            required: true,
            message: "医疗康复用房不能为空",
            trigger: "blur",
            type: "array",
          },
        ],
        culturalEntertainmentHousing: [
          {
            required: true,
            message: "文化娱乐用房不能为空",
            trigger: "blur",
            type: "array",
          },
        ],
        administrativeAuxiliaryHousing: [
          {
            required: true,
            message: "行政辅助用房不能为空",
            trigger: "blur",
            type: "array",
          },
        ],
        roomEquipment: [
          {
            required: true,
            message: "房间设备不能为空",
            trigger: "blur",
            type: "array",
          },
        ],
        publicServiceEquipment: [
          {
            required: true,
            message: "公共服务设备不能为空",
            trigger: "blur",
            type: "array",
          },
        ],
        medicalRehabilitationEquipment: [
          {
            required: true,
            message: "医疗康复设备不能为空",
            trigger: "blur",
            type: "array",
          },
        ],
        securityEquipment: [
          {
            required: true,
            message: "安全保障设备不能为空",
            trigger: "blur",
            type: "array",
          },
        ],
        fireSafetyEquipment: [
          {
            required: true,
            message: "消防安全设备不能为空",
            trigger: "blur",
            type: "array",
          },
        ],
        administrativeOffice: [
          {
            required: true,
            message: "行政办公设备不能为空",
            trigger: "blur",
            type: "array",
          },
        ],
      },
    }
  },
  created() {
    this.baseUrl = baseURL + "/ypt/controller/uploadController/info/uploadPhoto"

    this.formData = {
      organizationName: "",
      mechanismNature: 1,
      principal: "",
      telphone: "",
      legalRepresentative: "",
      phone: "",
      code: "",
      licenceFlag: 1,
      organizationLeval: 1,
      licence: "",
      medicalCareFlag: 1,
      servicePhone: "",
      medicalCareWay: 1,
      medicalPointFlag: 1,
      housResource: 1,
      mechanismBigType: 1,
      mechanismSmallType: 1,
      businessLicense: [],
      photo: [],
      introduction: "",
      actualInvestmentMoney: "",
      buildSubsidyMoney: "",
      staffNumber: "",
      houseNature: 1,
      houseType: 1,
      houseBuildTime: "",
      areaCovered: "",
      areaBuilding: "",
      yesToiletNumber: "",
      panicButtonFlag: 1,
      serviceHouseNumber: "",
      serviceBedNumber: "",
      activityVenues: 1,
      plantingArea: 1,
      breedingArea: 1,
      fireControlFlag: 1,
      parkingLotFlag: 1,
      carryOutServicesFlag: 1,
      floorPlan: [],
      roomEquipment: [],
      publicServiceHousing: [],
      medicalRehabilitationHousing: [],
      culturalEntertainmentHousing: [],
      administrativeAuxiliaryHousing: [],
      publicServiceEquipment: [],
      medicalRehabilitationEquipment: [],
      securityEquipment: [],
      fireSafetyEquipment: [],
      administrativeOffice: [],
      provinceId: "", //省
      cityId: "", //市
      zoneId: "", //区
      streetId: "", //街道
      shequId: "", //社区
      address: "",
      longitude: "",
      latitude: "",
      deviceId: "",
    }
    this.getProvince()
    if (this.openData.title == "新增") {
    } else {
      this.dataInfos()
    }
    this.getEquipList()
    this.getJoin()
    setTimeout(async () => {
      await this.$nextTick(() => this.loadmap())
    }, 200)
  },
  methods: {
    // 获取组织机构
    getJoin() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
            if (this.openData.title == "新增") {
              this.changeFirst()
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getEquipList() {
      this.$http
        .request({
          url: "/ypt/admin/equVendor/info/findData",
          method: "POST",
          data: {},
        })
        .then((res) => {
          // console.log(res)
          if (res.code == 200 && res.content) {
            this.equipList = res.content
          } else {
            this.equipList = []
          }
        })
    },
    async changeFirst() {
      // console.log(
      //     this.normalInfo,
      //     "机构信息 normalInfo.orgLevel",
      //     this.provinceList
      // )
      let province = await this.getDistricts()
      this.provinceList = province.districtList
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistricts(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
        // console.log("城市", this.cityList)
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getDistricts(this.normalInfo.cityId)
        this.areaList = areaList.districtList
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getDistricts(this.normalInfo.areaId)
        this.streetList = streetList.districtList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getCommityList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        this.areaList.forEach((item) => {
          if (item.adcode == this.normalInfo.areaId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.adcode + index == this.normalInfo.streetId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      }

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }
      this.formData.provinceId = this.normalInfo.provinceId
      this.formData.cityId = this.normalInfo.cityId
      this.formData.zoneId = this.normalInfo.areaId
      this.formData.streetId = this.normalInfo.streetId
      this.formData.shequId = this.normalInfo.communityId
      // this.potintMap()
      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
    // 打点
    potintMap() {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(this.formData.longitude),
          Number(this.formData.latitude),
        ],
      })
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },
    // 地图打点
    getMap(input) {
      const self = this
      const autoOptions = {
        city: self.formData.shequId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.formData.address = e.poi.name
        self.formData.longitude = e.poi.location.lng
        self.formData.latitude = e.poi.location.lat
        // console.log(e.poi.location, "地址")
        self.potintMap()
      })
    },
    async streetChange(val) {
      let communityList = await this.getCommityList(val)
      // console.log(communityList, "社区列表")
      this.communityList = communityList
      this.joinAddress()
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 地图显示隐藏
    mapTap() {
      this.showMap = !this.showMap
      if (this.formData.longitude && this.formData.latitude) {
        this.loadmap("container")
        setTimeout(() => {
          this.potintMap()
        }, 500)
      }
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 许可证
    licenseSuccess(res, file) {
      // this.$nextTick(() => {
      this.formData.businessLicense.push(res.content)
      // })
      this.$forceupdate()
    },
    // 楼层平面图
    houseSuccess(res, file) {
      // this.$nextTick(() => {
      this.formData.floorPlan.push(res.content)
      // })
      this.$forceupdate()
    },
    delLicense(index) {
      this.formData.businessLicense.splice(index, 1)
    },
    // 营业执照
    photoSuccess(res, file) {
      // this.$nextTick(() => {
      this.formData.photo.push(res.content)
      console.log(this.formData.photo, "我心中的图片")
      // })
      this.$forceupdate()
      // this.$set(this.formData, "photo", res.content)
    },
    // 按钮切换
    stepTap(nums) {
      this.step = nums
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList)
    },
    handlePreview(file) {
      // console.log(file)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 详情页信息
    dataInfos() {
      const self = this
      let params = {
        id: self.openData.id,
      }
      this.$http
        .request({
          url: "/ypt/admin/mechanismCare/info/get",
          method: "POST",
          data: params,
        })
        .then(async (res) => {
          if (res.code == 200) {
            let jsonTemp = { ...res.content }
            self.formData.id = jsonTemp.id
            self.formData.organizationName = jsonTemp.organizationName
            self.formData.mechanismNature = jsonTemp.mechanismNature
            self.formData.principal = jsonTemp.principal
            self.formData.telphone = jsonTemp.telphone
            self.formData.legalRepresentative = jsonTemp.legalRepresentative
            self.formData.phone = jsonTemp.phone
            self.formData.code = jsonTemp.code
            self.formData.licenceFlag = jsonTemp.licenceFlag
            self.formData.organizationLeval = jsonTemp.organizationLeval
            self.formData.roomEquipment = jsonTemp.roomEquipment.split(",")
            self.formData.licence = jsonTemp.licence
            self.formData.medicalCareFlag = jsonTemp.medicalCareFlag
            self.formData.servicePhone = jsonTemp.servicePhone
            self.formData.medicalCareWay = jsonTemp.medicalCareWay
            self.formData.medicalPointFlag = jsonTemp.medicalPointFlag
            self.formData.housResource = jsonTemp.housResource
            self.formData.mechanismBigType = jsonTemp.mechanismBigType
            self.formData.mechanismSmallType = jsonTemp.mechanismSmallType
            self.formData.businessLicense = jsonTemp.businessLicense.split(",")
            self.formData.photo = jsonTemp.photo.split(",")
            self.formData.introduction = jsonTemp.introduction
            self.formData.actualInvestmentMoney = jsonTemp.actualInvestmentMoney
            self.formData.buildSubsidyMoney = jsonTemp.buildSubsidyMoney
            self.formData.staffNumber = jsonTemp.staffNumber
            self.formData.deviceId = jsonTemp.deviceId
            self.formData.houseNature = jsonTemp.houseNature
            self.formData.houseType = jsonTemp.houseType
            self.formData.houseBuildTime = jsonTemp.houseBuildTime
            self.formData.areaCovered = jsonTemp.areaCovered
            self.formData.areaBuilding = jsonTemp.areaBuilding
            self.formData.yesToiletNumber = jsonTemp.yesToiletNumber
            self.formData.panicButtonFlag = jsonTemp.panicButtonFlag
            self.formData.serviceHouseNumber = jsonTemp.serviceHouseNumber
            self.formData.serviceBedNumber = jsonTemp.serviceBedNumber
            self.formData.activityVenues = jsonTemp.activityVenues
            self.formData.plantingArea = jsonTemp.plantingArea
            self.formData.breedingArea = jsonTemp.breedingArea
            self.formData.fireControlFlag = jsonTemp.fireControlFlag
            self.formData.parkingLotFlag = jsonTemp.parkingLotFlag
            self.formData.carryOutServicesFlag = jsonTemp.carryOutServicesFlag
            self.formData.floorPlan = jsonTemp.floorPlan.split(",")
            self.formData.publicServiceHousing =
              jsonTemp.publicServiceHousing.split(",")
            self.formData.medicalRehabilitationHousing =
              jsonTemp.medicalRehabilitationHousing.split(",")
            self.formData.culturalEntertainmentHousing =
              jsonTemp.culturalEntertainmentHousing.split(",")
            self.formData.administrativeAuxiliaryHousing =
              jsonTemp.administrativeAuxiliaryHousing.split(",")
            self.formData.publicServiceEquipment =
              jsonTemp.publicServiceEquipment.split(",")
            self.formData.medicalRehabilitationEquipment =
              jsonTemp.medicalRehabilitationEquipment.split(",")
            self.formData.securityEquipment =
              jsonTemp.securityEquipment.split(",")
            self.formData.fireSafetyEquipment =
              jsonTemp.fireSafetyEquipment.split(",")
            self.formData.administrativeOffice =
              jsonTemp.administrativeOffice.split(",")
            self.formData.longitude = jsonTemp.longitude
            self.formData.latitude = jsonTemp.latitude
            self.formData.address = jsonTemp.address
            self.formData.provinceId = String(jsonTemp.provinceId)
            self.formData.cityId = String(jsonTemp.cityId)
            self.formData.zoneId = String(jsonTemp.zoneId)
            self.formData.streetId = String(jsonTemp.streetId)
            self.formData.shequId = Number(jsonTemp.shequId)
            if (!self.formData.provinceId) return
            let city = await self.getDistricts(self.formData.provinceId)
            self.cityList = city.districtList
            if (!self.formData.cityId) return
            let area = await self.getDistricts(self.formData.cityId)
            self.areaList = area.districtList
            if (!self.formData.zoneId) return
            let street = await self.getDistricts(self.formData.zoneId)
            self.streetList = street.districtList
            if (!self.formData.streetId) return
            let communityList = await self.getCommityList(
              self.formData.streetId
            )
            self.communityList = communityList
          } else {
            this.$message.error(res.message)
          }
        })
    },

    //表格表单提交
    handleSubmit() {
      let self = this

      this.$refs.formData.validate((valid) => {
        if (valid) {
          if (this.openData.title == "新增" || this.openData.title == "编辑") {
            let url = ""

            if (!self.formData.provinceId) {
              self.$message.error("省级地址为必填项，请选择")
              return
            }
            if (!self.formData.cityId) {
              self.$message.error("市级地址为必填项，请选择")
              return
            }
            if (!self.formData.zoneId) {
              self.$message.error("区县级地址为必填项，请选择")
              return
            }
            if (!self.formData.streetId) {
              self.$message.error("街道地址为必填项，请选择")
              return
            }
            if (
              self.formData.shequId === "" ||
              self.formData.shequId === null ||
              self.formData.shequId === undefined
            ) {
              self.$message.error(
                "社区为必填项，请选择,如无对应社区，请地址管理配置"
              )
              return
            }
            if (!self.formData.address) {
              self.$message.error(
                "详细信息为必填项，请在地图的边界内点击选择或手动输入"
              )
              return
            }
            // delete this.formData.recTime
            const reg = /<\/?.+?\/?>/g
            this.formData.introduction = this.formData.introduction.replace(
              reg,
              ""
            )
            let data = { ...self.formData }
            data.photo = data.photo.join(",")
            data.businessLicense = data.businessLicense.join(",")
            data.floorPlan = data.floorPlan.join(",")
            data.publicServiceHousing = data.publicServiceHousing.join(",")
            data.medicalRehabilitationHousing =
              data.medicalRehabilitationHousing.join(",")
            data.culturalEntertainmentHousing =
              data.culturalEntertainmentHousing.join(",")
            data.administrativeAuxiliaryHousing =
              data.administrativeAuxiliaryHousing.join(",")
            data.roomEquipment = data.roomEquipment.join(",")
            data.publicServiceEquipment = data.publicServiceEquipment.join(",")
            data.medicalRehabilitationEquipment =
              data.medicalRehabilitationEquipment.join(",")
            data.securityEquipment = data.securityEquipment.join(",")
            data.fireSafetyEquipment = data.fireSafetyEquipment.join(",")
            data.administrativeOffice = data.administrativeOffice.join(",")

            url = "/ypt/admin/mechanismCare/info/save"
            this.$http
              .request({
                url: url,
                method: "POST",
                data: {
                  ...data,
                },
              })
              .then((res) => {
                if (res.code == 200) {
                  this.$message.success(res.message)
                } else {
                  this.$message.error(res.message)
                }
                this.$emit("cancleService", true)
              })
          }
        }
      })
    },

    joinAddress(address = "") {
      let self = this
      self.$nextTick(() => {
        let shengName = this.$refs.selectShengChange.selectedLabel
        let shiName = this.$refs.selectShiChange.selectedLabel
        let quName = this.$refs.selectQuChange.selectedLabel
        let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
        let shequName = this.$refs.selectShequChange.selectedLabel
        if (!address) {
          self.formData.address =
            shengName + shiName + quName + jiedaoName + shequName
        }
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }
        let geocoder = new AMap.Geocoder({ city: "" })
        self.marker = new AMap.Marker()
        geocoder.getLocation(this.formData.address, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            let lnglat = result.geocodes[0].location
            self.formData.longitude = lnglat.lng
            self.formData.latitude = lnglat.lat
            self.marker.setPosition(lnglat)
            self.myMap.add(self.marker)
            self.myMap.setFitView(self.marker)
          } else {
            log.error("根据地址查询位置失败")
          }
        })
      })
    },
    //获取地址
    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
            if (bounds) {
              try {
                self.myMap.remove(self.polygons)
              } catch (error) {
                console.log("移除地图编辑出错了")
              }
              self.polygons = []
              for (let i = 0, l = bounds.length; i < l; i++) {
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  strokeColor: "#0091ea",
                  fillColor: "#80d8ff",
                  fillOpacity: 0.4,
                  path: bounds[i],
                })
                self.polygons.push(self.polygon)
                if (!params) {
                  self.polygon.on("click", function (e) {
                    let lnglat = e.lnglat
                    self.myMap.add(self.marker)
                    self.marker.setPosition(lnglat)
                    geocoder.getAddress(lnglat, function (status, result) {
                      if (status === "complete" && result.regeocode) {
                        var address = result.regeocode.formattedAddress
                        self.formData.address = address
                        self.formData.longitude = lnglat.lng
                        self.formData.latitude = lnglat.lat
                      } else {
                        console.error("根据经纬度查询地址失败")
                      }
                    })
                  })
                  self.myMap.add(self.polygons)
                  self.myMap.setFitView() //地图自适应
                } else {
                  if (params.longitude && params.latitude) {
                    self.myMap.add(self.marker)
                    self.marker.setPosition([params.longitude, params.latitude])
                    self.myMap.setFitView(self.marker)
                    self.myMap.setZoom(11)
                  }
                }
              }
            }
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    //获取省级
    async getProvince() {
      this.provinceList = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.cityId = ""
      this.formData.zoneId = ""
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
      this.joinAddress()
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.zoneId = ""
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      let area = await this.getDistrict(val)
      this.areaList = area.districtList
      this.joinAddress()
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      // val = val.replace(/.$/, "");
      let street = await this.getDistrict(val)
      this.streetList = street.districtList
      this.joinAddress()
    },

    //加载地图
    loadmap() {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map("container", {
          resizeEnable: true,
          zoom: 18,
        })
        resolve()
      })
    },
    // 关闭人员信息
    dialogVisibleClone() {
      // this.openData.state=false;
      this.$emit("cancleService", false)
    },
  },
}
</script>
<style lang="less" scoped>
.avatar {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 200px;
  img {
    width: 200px;
    height: 200px;
    line-height: 200px;
    display: block;
  }
}
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 200px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 200px;
    line-height: 200px;
    text-align: center;
  }
}
.dialog-footer-btn {
  text-align: center;
}
/deep/.el-upload {
  border: none;
  width: auto;
}
.btnGroup {
  display: flex;
  justify-content: space-between;
  padding: 0 100px;
  margin-bottom: 30px;
}
.uplogImg {
  width: 120px;
  height: 120px;
}
</style>
